module.exports = __webpack_public_path__ + "static/map-frame-14c4b7ecce94b7f9801775dd415b0fde.png";